// Какво може да се каже за прехвърляне без да се рендира: анулирано ли е,
// складовете и посоката, кой го е въвел. Общо за началния екран, справката и
// документния модал.
import type { TransferDocument } from "../../../../api/inventoryTransfers";

export const isTransferAnnulled = (transfer: TransferDocument) =>
  transfer.status === "annulled" || !!transfer.deletedAt;

export const fromWarehouseOf = (transfer: TransferDocument) =>
  transfer.fromWarehouseName || "—";
export const toWarehouseOf = (transfer: TransferDocument) =>
  transfer.toWarehouseName || "—";
export const directionOf = (transfer: TransferDocument) =>
  `${fromWarehouseOf(transfer)} → ${toWarehouseOf(transfer)}`;

export const transferUserOf = (transfer: TransferDocument) =>
  transfer.createdByName || "—";

// Кога е въведено (BE с редизайна), иначе датата на документа
export const enteredAtOf = (transfer: TransferDocument) =>
  transfer.createdAt ?? transfer.date;
